export const Version = VERSION_STRING || '{{ version }}';
export const Domain = TARGET_ID || 'p1';
export const BaseUri = `http://${Domain}.joinmap.ai`; // 微信登录回调用
